import { Field } from '../types/fields';
import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';

export const getComponentFromComponentType = (formConfig: FormConfig, type: Field['type']) => {
    const elements = formConfig.pages.flatMap((page) => page.elements);

    const targetElement = elements.find((element) => element.type === type);

    return targetElement;
};
